import script from "./canva_cta_button.vue?vue&type=script&setup=true&lang=js"
export * from "./canva_cta_button.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__